import { ConfigService } from 'app/config/config.service';
import {
    Farm,
    farmSchema,
} from 'app/agriculture/contexts/RequiredStartupProviders/FarmContext/farmSchema';
import { z } from 'zod';
import { createAxiosInstance } from 'app/agriculture/queries/createAxiosInstance';
import { ApiEndpoint } from 'app/agriculture/queries/apiEndpoints';

export async function getFarms(): Promise<Farm[]> {
    const instance = createAxiosInstance();
    const { data } = await instance.get<unknown>(
        `${ConfigService.apiUrlRoot}agriculture${ApiEndpoint.farms}`,
    );

    return z.array(farmSchema).parse(data) as Farm[];
}
